// extracted by mini-css-extract-plugin
module.exports = {"h5button":"gu","h5Button":"gu","button":"gv","block":"gw","btnDefault":"gx","disable":"gy","btnPrimary":"gz"};